<template>
  <v-app id="portal">
    <v-content class="px-3">
      <titulo-responsivo
        :titulo="locale[local].screen.agendaAvaliacao.string001"
      />
      <v-divider />

      <div class="ma-5">
        <v-card outlined elevation="0">
          <v-card-text class="pa-0">
            <v-data-table
              :headers="headers"
              :items="items"
              :items-per-page="10"
            >
              <template v-slot:[`item.responder`]="{ item }">
                <div v-if="!item.responder" class="d-flex justify-center">
                  <v-btn
                    color="primary"
                    class="white--text"
                    small
                    @click="responder(item)"
                    width="150"
                    max-width="150"
                  >
                    <span>
                      {{ locale[local].screen.agendaAvaliacao.string002 }}
                    </span>
                    <v-icon right medium> mdi-draw-pen </v-icon>
                  </v-btn>
                </div>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </div>
    </v-content>

    <v-card>
      <v-card-text>
        <v-overlay v-model="carregando">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialogQuestionario">
      <v-container class="pt-16" style="background: #eceff1" fluid>
        <v-row justify="center">
          <v-col cols="12" md="5">
            <v-sheet v-if="controller.carregar" style="justify-content: center">
              <v-skeleton-loader
                v-model="controller.carregar"
                :loading="controller.carregar"
                type=" article,card,article,card,article, card, article,card"
              >
              </v-skeleton-loader>
            </v-sheet>
            <div
              v-else
              v-for="(titulo, index) in controller.questionario"
              :key="index"
            >
              <v-card class="mt-1" max-width="800">
                <v-card-title
                  class="text-md-body-1 primary"
                  style="color: white"
                  v-text="titulo.descricao"
                ></v-card-title>
              </v-card>

              <v-card
                v-for="(pergunta, i) in titulo.ttQuestPergunta"
                :key="i"
                elevation="0"
                class="mt-3 rounded-lg"
                max-width="800"
                :style="
                  pergunta.isShowError
                    ? 'border: 1px solid white;'
                    : 'border: 1px solid red;'
                "
              >
                <v-form lazy-validation :ref="'pergunta_' + index + '_' + i">
                  <v-card-subtitle class="text-justify text-md-body-1">
                    <b> {{ pergunta.descricao }} </b>
                  </v-card-subtitle>
                  <v-card-text>
                    <v-radio-group
                      @change="controller.validaCards(index, i)"
                      v-model="pergunta.codOpcao"
                      v-if="pergunta.resposta == 'I'"
                      :rules="[(v) => !!v || 'Está pergunta é obrigatória']"
                      required
                    >
                      <v-radio
                        class="text-md-body-1 text-md-body-2"
                        v-for="(q, x) in pergunta.ttQuestPerguntaOpcao"
                        :key="x"
                        :label="`${q.descricao}`"
                        :value="`${q.codOpcao}`"
                        required
                      ></v-radio>
                    </v-radio-group>
                    <v-checkbox
                      class="text-md-body-3 font-weight-regular mt-0"
                      v-else-if="pergunta.resposta == 'M'"
                      v-for="(q, x) in pergunta.ttQuestPerguntaOpcao"
                      :key="x"
                      v-model="pergunta.codOpcaoMulti"
                      :label="`${q.descricao}`"
                      :value="`${q.codOpcao}`"
                      required
                      :rules="[
                        (v) =>
                          v.length > 0 || locale[local].rules.perguntaLabel,
                      ]"
                      @change="controller.validaCards(index, i)"
                    ></v-checkbox>
                    <v-textarea
                      v-else-if="pergunta.resposta == 'D'"
                      v-model="pergunta.descricaoPergunta"
                      :label="
                        locale[local].screen.avaliacaoClima.descricaoLabel
                      "
                      required
                      rows="1"
                      :rules="[(v) => !!v || locale[local].rules.perguntaLabel]"
                      @change="controller.validaCards(index, i)"
                    ></v-textarea>

                    <div v-else-if="pergunta.resposta == 'U'">
                      <v-checkbox
                        class="text-md-body-3 font-weight-regular mt-0"
                        v-for="(q, x) in pergunta.ttQuestPerguntaOpcao"
                        :key="x"
                        v-model="pergunta.codOpcaoMulti"
                        :label="`${q.descricao}`"
                        :value="`${q.codOpcao}`"
                        :rules="[
                          (v) =>
                            v.length > 0 || locale[local].rules.perguntaLabel,
                        ]"
                        required
                        @change="controller.validaCards(index, i)"
                      ></v-checkbox>
                      <v-textarea
                        v-model="pergunta.descricaoPergunta"
                        :label="
                          locale[local].screen.avaliacaoClima.descricaoLabel
                        "
                        required
                        rows="1"
                        :rules="[
                          (v) => !!v || locale[local].rules.perguntaLabel,
                        ]"
                        @change="controller.validaCards(index, i)"
                      ></v-textarea>
                    </div>
                    <div v-else-if="pergunta.resposta == 'S'">
                      <v-radio-group
                        v-model="pergunta.codOpcao"
                        :rules="[
                          (v) => !!v || locale[local].rules.perguntaLabel,
                        ]"
                        @change="controller.validaCards(index, i)"
                      >
                        <v-radio
                          class="text-md-body-1 text-md-body-2"
                          v-for="(q, x) in pergunta.ttQuestPerguntaOpcao"
                          :key="x"
                          :label="`${q.descricao}`"
                          :value="`${q.codOpcao}`"
                        ></v-radio>
                      </v-radio-group>
                      <v-textarea
                        v-model="pergunta.descricaoPergunta"
                        :label="
                          locale[local].screen.avaliacaoClima.descricaoLabel
                        "
                        required
                        rows="1"
                        :rules="[
                          (v) => !!v || locale[local].rules.perguntaLabel,
                        ]"
                        @change="controller.validaCards(index, i)"
                      ></v-textarea>
                    </div>
                    <v-checkbox
                      v-if="pergunta.permiteDesabilitar === true"
                      :label="locale[local].screen.avaliacaoClima.naoSeAplica"
                      v-model="pergunta.naoSeAplica"
                      @change="controller.validaCards(index, i)"
                    ></v-checkbox>
                  </v-card-text>
                </v-form>
              </v-card>
            </div>
          </v-col>
        </v-row>

        <v-row justify="center">
          <v-col cols="4" md="2">
            <v-btn
              color="red"
              class="mt-5"
              outlined
              :loading="controller.loading"
              @click="dialogQuestionario = false"
            >
              <v-icon left>mdi-close</v-icon> Fechar
            </v-btn>
          </v-col>


          <v-col cols="4" md="2">
            <v-btn
              outlined
              class="mt-5"
              color="primary"
              :loading="controller.loading"
              @click="controller.enviar()"
            >
              <v-icon>mdi-send</v-icon>
              Enviar
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-dialog>
  </v-app>
</template>

<script>
import Service from "../components/api/Service";
import moment from "moment";
import AvaliacaoClima from "../../state/avaliacaoClima/avaliacaoClima";

export default {
  data: (context) => ({
    controller: new AvaliacaoClima(context),
    snackbar: false,
    loading: false,
    dialogQuestionario: false,
    headers: [
      {
        text: "Empresa",
        value: "codEmp",
        divider: true,
      },
      {
        text: "Empregado",
        value: "codEmpregado",
        divider: true,
      },
      {
        text: "Questionário",
        value: "codQuestionario",
        divider: true,
      },
      {
        text: "Descrição",
        value: "nomeQuestionario",
        divider: true,
      },
      {
        text: "Data Limite",
        value: "dtLimiteChar",
        divider: true,
      },
      {
        text: "Treinamento",
        value: "nomeTreinamento",
        divider: true,
      },
      {
        text: "Turma",
        value: "codTurma",
        divider: true,
      },
      {
        text: "Responder",
        value: "responder",
        align: "center",
        custom: true,
        divider: true,
      },
    ],
    items: [],
    carregando: false,
  }),
  async mounted() {},
  created() {
    moment.locale("pt-br");
    this.buscarAgenda();
  },
  methods: {
    async buscarAgenda() {
      this.loading = true;
      this.carregando = true;

      try {
        const service = new Service();
        this.items = await service.getBuscaAgenda();

        this.loading = false;
      } catch (e) {
        this.loading = false;
      } finally {
        this.carregando = false;
      }
    },
    async responder(agenda) {
      await this.controller.getQuestionario(agenda);
      this.dialogQuestionario = true;
    },
  },
};
</script>
